import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'

import { VEHICLE_COMPONENT } from 'features/VehicleTemplates/components/Components/constants'
import { ComponentIcon } from 'features/VehicleTemplates/components/Components/Icon'
import { vehicleComponentMessages } from 'features/VehicleTemplates/components/Components/messages'

const Wrapper = styled.div<TSFixMe>`
  width: 225px;
  background-color: #9999bd;
  border-radius: 4.4px;
  color: #ffffff;
`

const Container = styled.div<TSFixMe>`
  padding: 20px;
`

const Title = styled.h5<TSFixMe>`
  margin: 0 0 20px;
  font-size: 15px;
  font-weight: normal;
`

const Components = styled.div<TSFixMe>`
  margin: -5px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`

const Component = styled.div<TSFixMe>`
  margin: 5px;
  width: calc(50% - 12px);
  padding: 5px 0;
  background-color: ${(props): TSFixMe => (props.isActive ? '#ffffff' : 'transparent')};
  color: ${(props): TSFixMe => (props.isActive ? '#9999bd' : '#ffffff')};
  box-shadow: 0 2px 4px 0 rgba(105, 105, 128, 0.62);
  border-style: solid;
  border-width: 1px;
  border-color: ${(props): TSFixMe => (props.isActive ? '#c7c7ff' : '#ffffff')};
  border-radius: 5px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  text-align: center;
  min-height: 43px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;

  svg {
    fill: ${(props): TSFixMe => (props.isActive ? '#9999bd' : '#ffffff')};
  }
`

const COMPONENT_LIST = [
  VEHICLE_COMPONENT.SEAT,
  VEHICLE_COMPONENT.DRIVER,
  VEHICLE_COMPONENT.DOOR,
  VEHICLE_COMPONENT.WC,
  VEHICLE_COMPONENT.STAIRCASE,
  VEHICLE_COMPONENT.EMPTY
]

export const SelectComponent = ({ selectedComponent, ...props }: TSFixMe): TSFixMe => {
  const intl = useIntl()

  return (
    <Wrapper>
      <Container>
        <Title>
          <FormattedMessage id="vehicleTemplates.form.selectComponent.title" defaultMessage="Add components" />
        </Title>

        <Components>
          {COMPONENT_LIST.map((component): TSFixMe => {
            return (
              <Component
                key={component}
                isActive={selectedComponent === component}
                onClick={(): TSFixMe => props.onChange(component)}
              >
                <div>
                  <ComponentIcon component={component} />
                </div>

                <div>{intl.formatMessage(vehicleComponentMessages[component])}</div>
              </Component>
            )
          })}
        </Components>
      </Container>
    </Wrapper>
  )
}
